module.exports = __webpack_public_path__ + "img/hr-red-desert-decal-09.b270ec47.png";